export enum CustomerLoginType {
   Customer = 'Customer',
   Alias = 'Alias',
   SingleSignOnSession = 'SingleSignOnSession',
   Anonymous = 'Anonymous'
}

export namespace CustomerLoginType {
   export function ToNumber(type: CustomerLoginType): number {
      switch (type) {
         case CustomerLoginType.Customer:
            return 1;
         case CustomerLoginType.Alias:
            return 2;
         case CustomerLoginType.SingleSignOnSession:
            return 3;
         case CustomerLoginType.Anonymous:
         default:
            return 4;
      }
   }

   export function FromNumber(type: number): CustomerLoginType {
      switch (type) {
         case 1:
            return CustomerLoginType.Customer;
         case 2:
            return CustomerLoginType.Alias;
         case 3:
            return CustomerLoginType.SingleSignOnSession;
         case 4:
         default:
            return CustomerLoginType.Anonymous;
      }
   }
}

